import _isString from 'lodash/isString';
import _isPlainObject from 'lodash/isPlainObject';
import _isArray from 'lodash/isArray';
import _isBoolean from 'lodash/isBoolean';
import _isNumber from 'lodash/isNumber';
import _mergeWith from 'lodash/mergeWith';
import _cloneDeep from 'lodash/cloneDeep';

function parseJSONParams(paramsAsString, defaultValue) {
  try {
    return JSON.parse(paramsAsString);
  } catch (err) {
    return defaultValue;
  }
}

function mergeCustomizer(defaultValue, remoteValue) {
  // массивы (flow, feedbacks, magicStages, advantages) заменяем целиком:
  // поэлементный merge смешал бы значения из мутатора с дефолтными
  if (_isArray(defaultValue) || _isArray(remoteValue)) {
    return remoteValue === undefined || remoteValue === null ? defaultValue : remoteValue;
  }
  // незаполненное значение в мутаторе не должно перебивать дефолт
  if (remoteValue === '' || remoteValue === null) {
    return defaultValue;
  }
  return undefined;
}

// Мутатор отдаёт JSON-параметр целиком, поэтому ключ, забытый внутри него,
// раньше долетал до юзера как undefined — дефолты применялись только к верхнему уровню.
function mergeWithDefaults(remoteValue, defaultValue) {
  if (!_isPlainObject(defaultValue) || !_isPlainObject(remoteValue)) {
    return remoteValue;
  }
  return _mergeWith({}, _cloneDeep(defaultValue), remoteValue, mergeCustomizer);
}

function convertType(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (_isString(defaultValue)) {
    return value || defaultValue;
  }
  if (_isPlainObject(defaultValue)) {
    return mergeWithDefaults(parseJSONParams(value, defaultValue), defaultValue);
  }
  if (_isArray(defaultValue)) {
    return parseJSONParams(value, defaultValue);
  }
  if (_isBoolean(defaultValue)) {
    return !!value;
  }
  if (_isNumber(defaultValue)) {
    return value;
  }
  return value;
}

function createRemoteConfigSnapshotNormalizer(defaultValues, enableLogger = false) {
  return function (snapshot) {
    if (enableLogger) {
      console.log('Normalizer: param names', Object.keys(defaultValues));
      console.log('Normalizer: snapshot', snapshot);
    }

    const remoteConfig = Object.keys(defaultValues).reduce(
      (convertedData, paramName) =>
        Object.assign(convertedData, {
          [paramName]: convertType(snapshot[paramName], defaultValues[paramName]),
        }),
      {},
    );

    if (enableLogger) {
      console.log('Normalizer: normalized remoteConfig', remoteConfig);
    }
    return { remoteConfig, snapshot };
  };
}

export default createRemoteConfigSnapshotNormalizer;
